module.exports = __webpack_public_path__ + "static/media/about_top.90520056.jpg";